import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['name', 'holderId', 'options']

  connect () {
    this.select()
  }

  select () {
    const option = Array.from(this.optionsTarget.options).find(({ value }) => value === this.nameTarget.value)
    this.holderIdTarget.value = option?.dataset.id || ''
    this.holderIdTarget.disabled = option === undefined
  }
}
